import { render } from "./SettingPersonal.vue?vue&type=template&id=4410230c"
import script from "./SettingPersonal.vue?vue&type=script&lang=js"
export * from "./SettingPersonal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__